// eslint-disable-next-line import/prefer-default-export
export const TimeUnit = Object.freeze({
    Hour: 0,
    Day: 1,
});
